import React from 'react';
import { Flex, Icon, Text } from '@spothero/ui';
import IconCircleCheck from '@spothero/icons/checkmark-circle-filled';
import { getFeatureVariation, OPTIMIZELY_FEATURE_ON, } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import dayjs from 'utils/dayjs-duration';
const AirportCancellationCallout = ({ cancellationAllowed, cancellationMinutes = 0, isAirport, optimizely, }) => {
    const shouldShowAirportCancellationCallout = () => {
        let showCancellation = false;
        try {
            if (cancellationAllowed && isAirport) {
                showCancellation =
                    getFeatureVariation(optimizely, IMMEDIATE_FEATURES.AIRPORT_CANCELLATION_CALLOUT, {
                        generateImpression: true,
                    }) === OPTIMIZELY_FEATURE_ON;
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in shouldShowAirportCancellationCallout', e);
        }
        return showCancellation;
    };
    if (!shouldShowAirportCancellationCallout()) {
        return null;
    }
    return (<Flex justifyContent="center" alignItems="center" mb={4}>
            <Icon as={IconCircleCheck} color="green.700" fontSize="md" marginRight={1}/>
            <Text fontSize="sm">
                Cancel free until{' '}
                {cancellationMinutes > 0
            ? `${dayjs
                .duration(cancellationMinutes, 'minutes')
                .asHours()} hours before the reservation start time`
            : `start time`}
            </Text>
        </Flex>);
};
export default AirportCancellationCallout;
